const char_roman_to_tai = [
  //{ id: "n’</w>ti<w>", value: "nti" },
  { id: "ndr", value: "nrd" },
  { id: "ntr", value: "nrt" },
  { id: "bbho", value: "ᨻᩮ᩠ᨽᩣ" },
  { id: "ccho", value: "ᨧᩮ᩠ᨨᩣ" },
  { id: "ddho", value: "ᨴᩮ᩠ᨵᩣ" },
  { id: "ḍḍho", value: "ᨯᩮ᩠ᨰᩣ" },
  { id: "ggho", value: "ᨣᩮ᩠ᨥᩣ" },
  { id: "jjho", value: "ᨩᩮ᩠ᨫᩣ" },
  { id: "kkho", value: "ᨠᩮ᩠ᨡᩣ" },
  { id: "mbho", value: "ᨾᩮ᩠ᨽᩣ" },
  { id: "mpho", value: "ᨾᩮ᩠ᨹᩣ" },
  { id: "ndho", value: "ᨶᩮᩣ᩠ᨵ" },
  { id: "ntho", value: "ᨶᩮᩣ᩠ᨳ" },
  { id: "ndhā", value: "ᨶᩣ᩠ᨵ" },
  { id: "nthā", value: "ᨶᩣ᩠ᨳ" },
  { id: "ṅgho", value: "ᩘᨥᩮᩣ" }, //  "ᩘᩮ᩠ᨿᩣ
  { id: "ṅkho", value: "ᩘᨡᩮᩣ" }, // "ᩘᩮ᩠ᨡᩣ"
  { id: "ñcho", value: "ᨬᩮ᩠ᨨᩣ" },
  { id: "ñjho", value: "ᨬᩮ᩠ᨫᩣ" },
  { id: "ṇḍho", value: "ᨱᩮ᩠ᨰᩣ" },
  { id: "ṇṭho", value: "ᨱᩮ᩠ᨮᩣ" },
  { id: "ppho", value: "ᨷᩮ᩠ᨹᩣ" },
  { id: "ttho", value: "ᨲᩮ᩠ᨳᩣ" },
  { id: "ṭṭho", value: "ᨭᩛᩮᩣ" },
  { id: "bbhe", value: "ᨻᩮ᩠ᨽ" },
  { id: "mbhe", value: "ᨾᩮ᩠ᨽ" },
  { id: "cche", value: "ᨧᩮ᩠ᨨ" },
  { id: "ñche", value: "ᨬᩮ᩠ᨨ" },
  { id: "ddhe", value: "ᨴᩮ᩠ᨵ" },
  { id: "ndhe", value: "ᨶᩮ᩠ᨵ" },
  { id: "ḍḍhe", value: "ᨯᩮ᩠ᨰ" },
  { id: "ṇḍhe", value: "ᨱᩮ᩠ᨰ" },
  { id: "gghe", value: "ᨣᩮ᩠ᨥ" },
  { id: "ṅghe", value: "ᩘᨥᩮ" }, //  "ᩘᩮ᩠ᨿ
  { id: "ṅkhe", value: "ᩘᨡᩮ" }, // "ᩘᩮ᩠ᨡ
  { id: "jjhe", value: "ᨩᩮ᩠ᨫ" },
  { id: "ñjhe", value: "ᨬᩮ᩠ᨫ" },
  { id: "kkhe", value: "ᨠᩮ᩠ᨡ" },
  { id: "mphe", value: "ᨾᩮ᩠ᨹ" },
  { id: "pphe", value: "ᨷᩮ᩠ᨹ" },
  { id: "nthe", value: "ᨶᩮ᩠ᨳ" },
  { id: "tthe", value: "ᨲᩮ᩠ᨳ" },
  { id: "ṇṭhe", value: "ᨱᩮ᩠ᨮ" },
  { id: "ṭṭhe", value: "ᨭᩛᩮ" },
  { id: "bbo", value: "ᨻᩮ᩠ᨻᩣ" },
  { id: "cco", value: "ᨧᩮ᩠ᨧᩣ" },
  { id: "ddo", value: "ᨴᩮ᩠ᨴᩣ" },
  { id: "dvo", value: "ᨴᩮ᩠ᩅᩣ" },
  { id: "ḍḍo", value: "ᨯᩮ᩠ᨯᩣ" },
  { id: "ggo", value: "ᨣᩮ᩠ᨣᩣ" },
  { id: "hro", value: "ᩉᩮ᩠ᩕᩣ" },
  { id: "hvo", value: "ᩉᩮ᩠ᩅᩣ" },
  { id: "hyo", value: "ᩉᩮ᩠ᨿᩣ" },
  { id: "jjo", value: "ᨩᩮ᩠ᨩᩣ" },
  { id: "kko", value: "ᨠᩮ᩠ᨠᩣ" },
  { id: "kro", value: "ᨠᩮ᩠ᩕᩣ" },
  { id: "mbo", value: "ᨾᩮ᩠ᨻᩣ" },
  { id: "llo", value: "ᩃᩮ᩠ᩃᩣ" },
  { id: "mmo", value: "ᨾᩮᩜᩣ" },
  { id: "mpo", value: "ᨾᩮ᩠ᨷᩣ" },
  { id: "ndo", value: "ᨶᩮᩣ᩠ᨴ" },
  { id: "nno", value: "ᨶᩮᩣ᩠ᨶ" },
  { id: "nto", value: "ᨶᩮᩣ᩠ᨲ" },
  { id: "ndā", value: "ᨶᩣ᩠ᨴ" },
  { id: "nnā", value: "ᨶᩣ᩠ᨶ" },
  { id: "ntā", value: "ᨶᩣ᩠ᨲ" },
  { id: "ṅgo", value: "ᩘ ᨣᩮᩤ" }, //  ᩘᩮ᩠ᨣᩣ
  { id: "ṅko", value: "ᩘᨠᩮᩣ" }, //  ᩘᩮ᩠ᨠᩣ
  { id: "ñco", value: "ᨬᩮ᩠ᨧᩣ" },
  { id: "ñjo", value: "ᨬᩮ᩠ᨩᩣ" },
  { id: "ñño", value: "ᨬᩮ᩠ᨬᩣ" },
  { id: "ṇḍo", value: "ᨱᩮ᩠ᨯᩣ" },
  { id: "ṇṇo", value: "ᨱᩮ᩠ᨱᩣ" },
  { id: "ṇṭo", value: "ᨱᩮ᩠ᨭᩣ" },
  { id: "ppo", value: "ᨷᩮ᩠ᨷᩣ" },
  { id: "rho", value: "ᩁᩮ᩠ᩉᩣ" },
  { id: "rvo", value: "ᩁᩮ᩠ᩅᩣ" },
  { id: "ryo", value: "ᩁᩮ᩠ᨿᩣ" },
  { id: "tto", value: "ᨲᩮ᩠ᨲᩣ" },
  { id: "tvo", value: "ᨲᩮ᩠ᩅᩣ" },
  { id: "ṭṭo", value: "ᨭᩮ᩠ᨭᩣ" },
  { id: "vho", value: "ᩅᩮ᩠ᩉᩣ" },
  { id: "vro", value: "ᩅᩮ᩠ᩕᩣ" },
  { id: "vyo", value: "ᩅᩮ᩠ᨿᩣ" },
  { id: "yho", value: "ᨿᩮ᩠ᩉᩣ" },
  { id: "yro", value: "ᨿᩮ᩠ᩕᩣ" },
  { id: "yvo", value: "ᨿᩮ᩠ᩅᩣ" },
  { id: "yyo", value: "ᨿᩮ᩠ᨿᩣ" },
  { id: "bbe", value: "ᨻᩮ᩠ᨻ" },
  { id: "mbe", value: "ᨾᩮ᩠ᨻ" },
  { id: "cce", value: "ᨧᩮ᩠ᨧ" },
  { id: "ñce", value: "ᨬᩮ᩠ᨧ" },
  { id: "dde", value: "ᨴᩮ᩠ᨴ" },
  { id: "nde", value: "ᨶᩮ᩠ᨴ" },
  { id: "ḍḍe", value: "ᨯᩮ᩠ᨯ" },
  { id: "ṇḍe", value: "ᨱᩮ᩠ᨯ" },
  { id: "gge", value: "ᨣᩮ᩠ᨣ" },
  { id: "ṅge", value: "ᩘᨣᩮ" }, // "ᩘᩮ᩠ᨣ
  { id: "rhe", value: "ᩁᩮ᩠ᩉ" },
  { id: "vhe", value: "ᩅᩮ᩠ᩉ" },
  { id: "yhe", value: "ᨿᩮ᩠ᩉ" },
  { id: "jje", value: "ᨩᩮ᩠ᨩ" },
  { id: "ñje", value: "ᨬᩮ᩠ᨩ" },
  { id: "kke", value: "ᨠᩮ᩠ᨠ" },
  { id: "ṅke", value: "ᩘᨠᩮ" }, //  ᩘᩮ᩠ᨠ
  { id: "mme", value: "ᨾᩮᩜ" },
  { id: "lle", value: "ᩃᩮ᩠ᩃ" },
  { id: "nne", value: "ᨶᩮ᩠ᨶ" },
  { id: "ññe", value: "ᨬᩮ᩠ᨬ" },
  { id: "ṇṇe", value: "ᨱᩮ᩠ᨱ" },
  { id: "mpe", value: "ᨾᩮ᩠ᨷ" },
  { id: "ppe", value: "ᨷᩮ᩠ᨷ" },
  { id: "hre", value: "ᩉᩮ᩠ᩕ" },
  { id: "kre", value: "ᨠᩮ᩠ᩕ" },
  { id: "vre", value: "ᩅᩮ᩠ᩕ" },
  { id: "yre", value: "ᨿᩮ᩠ᩕ" },
  { id: "nte", value: "ᨶᩮ᩠ᨲ" },
  { id: "tte", value: "ᨲᩮ᩠ᨲ" },
  { id: "ṇṭe", value: "ᨱᩮ᩠ᨭ" },
  { id: "ṭṭe", value: "ᨭᩮ᩠ᨭ" },
  { id: "dve", value: "ᨴᩮ᩠ᩅ" },
  { id: "hve", value: "ᩉᩮ᩠ᩅ" },
  { id: "rve", value: "ᩁᩮ᩠ᩅ" },
  { id: "tve", value: "ᨲᩮ᩠ᩅ" },
  { id: "yve", value: "ᨿᩮ᩠ᩅ" },
  { id: "hye", value: "ᩉᩮ᩠ᨿ" },
  { id: "rye", value: "ᩁᩮ᩠ᨿ" },
  { id: "vye", value: "ᩅᩮ᩠ᨿ" },
  { id: "yye", value: "ᨿᩮ᩠ᨿ" },
  //{ id: "mmā", value: "ᨾᩜᩣ" },
  //{ id: "mma", value: "ᨾᩜ" },
  { id: "by", value: "ᨻ᩠ᨿ᩠" },
  { id: "ṭṭh", value: "ᨭᩛ᩠" },

  { id: "ss", value: "ᩔ᩠" },
  { id: "vh", value: "ᩅ᩠ᩉ᩠" },
  { id: "vy", value: "ᩅ᩠ᨿ᩠" },
  { id: "vr", value: "ᩅᩕ᩠" },
  { id: "yh", value: "ᨿ᩠ᩉ᩠" },
  { id: "yy", value: "ᨿ᩠ᨿ᩠" },
  { id: "yr", value: "ᨿᩕ᩠" },
  { id: "yv", value: "ᨿ᩠ᩅ᩠" },
  { id: "hy", value: "ᩉ᩠ᨿ᩠" },
  { id: "hr", value: "ᩉᩕ᩠" },
  { id: "hv", value: "ᩉ᩠ᩅ᩠" },
  { id: "rv", value: "ᩁ᩠ᩅ᩠" },
  { id: "rh", value: "ᩁ᩠ᩉ᩠" },
  { id: "ry", value: "ᩁ᩠ᨿ᩠" },
  { id: "kh", value: "ᨡ᩠" },
  { id: "gh", value: "ᨥ᩠" },
  { id: "ch", value: "ᨨ᩠" },
  { id: "jh", value: "ᨫ᩠" },
  { id: "ññ", value: "ᨬ᩠ᨬ᩠" },
  { id: "ṭh", value: "ᨮ᩠" },
  { id: "ḍh", value: "ᨰ᩠" },
  { id: "th", value: "ᨳ᩠" },
  { id: "dh", value: "ᨵ᩠" },
  { id: "ph", value: "ᨹ᩠" },
  { id: "bh", value: "ᨽ᩠" },
  { id: "k", value: "ᨠ᩠" },
  { id: "g", value: "ᨣ᩠" },
  { id: "c", value: "ᨧ᩠" },
  { id: "j", value: "ᨩ᩠" },
  { id: "ñ", value: "ᨬ᩠" },
  { id: "ḷ", value: "ᩊ᩠" },
  { id: "ṭ", value: "ᨭ᩠" },
  { id: "ḍ", value: "ᨯ᩠" },
  { id: "ṇ", value: "ᨱ᩠" },
  { id: "t", value: "ᨲ᩠" },
  { id: "d", value: "ᨴ᩠" },
  { id: "n", value: "ᨶ᩠" },
  { id: "p", value: "ᨷ᩠" },
  { id: "b", value: "ᨻ᩠" },
  { id: "m", value: "ᨾ᩠" },
  { id: "l", value: "ᩃ᩠" },
  { id: "s", value: "ᩈ᩠" },
  { id: "ṅ", value: "ᩘ" },
  { id: "᩠h", value: "᩠ᩉ᩠" },
  { id: "h", value: "ᩉ᩠" },
  { id: "᩠y", value: "᩠ᨿ" },
  { id: "y", value: "ᨿ᩠" },
  { id: "᩠r", value: "ᩕ᩠" },
  { id: "r", value: "ᩁ᩠" },
  { id: "᩠v", value: "᩠ᩅ᩠" },
  { id: "v", value: "ᩅ᩠" },
  { id: "᩠ᨾ", value: "ᩜ" },
  { id: "᩠ai", value: "ᩱ" },
  { id: "᩠aṃ", value: "ᩴ" },
  { id: "᩠iṃ", value: "ᩥᩴ" },
  { id: "᩠uṃ", value: "ᩩᩴ" },
  { id: "᩠ā", value: "ᩣ" },
  { id: "᩠i", value: "ᩥ" },
  { id: "᩠ī", value: "ᩦ" },
  { id: "᩠u", value: "ᩩ" },
  { id: "᩠ū", value: "ᩪ" },
  { id: "᩠e", value: "ᩮ" },
  { id: "᩠o", value: "ᩮᩣ" },
  { id: "aṃ", value: "ᩋᩴ" },
  { id: "iṃ", value: "ᨠ᩠ᨠᩴ" },
  { id: "uṃ", value: "ᩏᩴ" },
  { id: "a", value: "ᩋ" },
  { id: "ā", value: "ᩋᩣ" },
  { id: "i", value: "ᩍ" },
  { id: "ī", value: "ᩎ" },
  { id: "u", value: "ᩏ" },
  { id: "ū", value: "ᩐ" },
  { id: "e", value: "ᩑ" },
  { id: "o", value: "ᩒ" },
  { id: "᩠᩼ᩋ", value: "" },
  { id: "᩠ᩋ", value: "" },
  //{ id: "ᨡᩮᩣ", value: "ᨡᩮᩤ" },
  //{ id: "ᨡᩣ", value: "ᨡᩤ" },
  { id: "ᨠ᩠ᨡᩮᩤ", value: "ᨠᩮ᩠ᨡᩣ" },
  { id: "က᩠ခါ", value: "ᨠ᩠ᨡᩣ" },
  { id: "ဂော", value: "ᨣᩮᩤ" },
  //{ id: "ᨦᩮᩣ", value: "ᨦᩮᩤ" },
  { id: "ᨴᩮᩣ", value: "ᨴᩮᩤ" },
  { id: "ᨷᩮᩣ", value: "ᨷᩮᩤ" },
  { id: "ᩅᩮᩣ", value: "ᩅᩮᩤ" },
  { id: "ᨣᩣ", value: "ᨣᩤ" },
  //{ id: "ᨦᩣ", value: "ᨦᩤ" },
  { id: "ᨴᩣ", value: "ᨴᩤ" },
  { id: "ᨵᩣ", value: "ᨵᩤ" },
  { id: "ᨷᩣ", value: "ᨷᩤ" },
  { id: "ᩅᩣ", value: "ᩅᩤ" },
  { id: "ᨴ᩠ᩅᩣ", value: "ᨴ᩠ᩅᩤ" },
  { id: "ᩘ ", value: "ᩘ" },
  { id: "ᨷ᩠ᨷᩤ", value: "ᨷ᩠ᨷᩣ" },
  { id: "ᨲ᩠ᩅᩤ", value: "ᨲ᩠ᩅᩣ" },
  { id: "ᩈ᩠ᩅᩤ", value: "ᩈ᩠ᩅᩣ" },
  { id: "ᩮ᩠ᨷᩤ", value: "ᩮ᩠ᨷᩣ" },
];

/*
const char_tai_to_roman = [
  { id: "ᨻᩮ᩠ᨽᩣ", value: "bbho" },
  { id: "ᨧᩮ᩠ᨨᩣ", value: "ccho" },
  { id: "ᨴᩮ᩠ᨵᩣ", value: "ddho" },
  { id: "ᨯᩮ᩠ᨰᩣ", value: "ḍḍho" },
  { id: "ᨣᩮ᩠ᨥᩣ", value: "ggho" },
  { id: "ᨩᩮ᩠ᨫᩣ", value: "jjho" },
  { id: "ᨠᩮ᩠ᨡᩣ", value: "kkho" },
  { id: "ᨾᩮ᩠ᨽᩣ", value: "mbho" },
  { id: "ᨾᩮ᩠ᨹᩣ", value: "mpho" },
  { id: "ᨶᩮᩣ᩠ᨵ", value: "ndho" },
  { id: "ᨶᩮᩣ᩠ᨳ", value: "ntho" },
  { id: "ᨶᩣ᩠ᨵ", value: "ndhā" },
  { id: "ᨶᩣ᩠ᨳ", value: "nthā" },
  { id: "ᩘᨥᩮᩣ", value: "ṅgho" },
  { id: "ᩘᨡᩮᩣ", value: "ṅkho" },
  { id: "ᨬᩮ᩠ᨨᩣ", value: "ñcho" },
  { id: "ᨬᩮ᩠ᨫᩣ", value: "ñjho" },
  { id: "ᨱᩮ᩠ᨰᩣ", value: "ṇḍho" },
  { id: "ᨱᩮ᩠ᨮᩣ", value: "ṇṭho" },
  { id: "ᨷᩮ᩠ᨹᩣ", value: "ppho" },
  { id: "ᨲᩮ᩠ᨳᩣ", value: "ttho" },
  { id: "ᨭᩛᩮᩣ", value: "ṭṭho" },
  { id: "ᨻᩮ᩠ᨽ", value: "bbhe" },
  { id: "ᨾᩮ᩠ᨽ", value: "mbhe" },
  { id: "ᨧᩮ᩠ᨨ", value: "cche" },
  { id: "ᨬᩮ᩠ᨨ", value: "ñche" },
  { id: "ᨴᩮ᩠ᨵ", value: "ddhe" },
  { id: "ᨶᩮ᩠ᨵ", value: "ndhe" },
  { id: "ᨯᩮ᩠ᨰ", value: "ḍḍhe" },
  { id: "ᨱᩮ᩠ᨰ", value: "ṇḍhe" },
  { id: "ᨣᩮ᩠ᨥ", value: "gghe" },
  { id: "ᩘᨥᩮ", value: "ṅghe" },
  { id: "ᩘᨡᩮ", value: "ṅkhe" },
  { id: "ᨩᩮ᩠ᨫ", value: "jjhe" },
  { id: "ᨬᩮ᩠ᨫ", value: "ñjhe" },
  { id: "ᨠᩮ᩠ᨡ", value: "kkhe" },
  { id: "ᨾᩮ᩠ᨹ", value: "mphe" },
  { id: "ᨷᩮ᩠ᨹ", value: "pphe" },
  { id: "ᨶᩮ᩠ᨳ", value: "nthe" },
  { id: "ᨲᩮ᩠ᨳ", value: "tthe" },
  { id: "ᨱᩮ᩠ᨮ", value: "ṇṭhe" },
  { id: "ᨭᩛᩮ", value: "ṭṭhe" },
  { id: "ᨻᩮ᩠ᨻᩣ", value: "bbo" },
  { id: "ᨧᩮ᩠ᨧᩣ", value: "cco" },
  { id: "ᨴᩮ᩠ᨴᩣ", value: "ddo" },
  { id: "ᨴᩮ᩠ᩅᩣ", value: "dvo" },
  { id: "ᨯᩮ᩠ᨯᩣ", value: "ḍḍo" },
  { id: "ᨣᩮ᩠ᨣᩣ", value: "ggo" },
  { id: "ᩉᩮ᩠ᩕᩣ", value: "hro" },
  { id: "ᩉᩮ᩠ᩅᩣ", value: "hvo" },
  { id: "ᩉᩮ᩠ᨿᩣ", value: "hyo" },
  { id: "ᨩᩮ᩠ᨩᩣ", value: "jjo" },
  { id: "ᨠᩮ᩠ᨠᩣ", value: "kko" },
  { id: "ᨠᩮ᩠ᩕᩣ", value: "kro" },
  { id: "ᨾᩮ᩠ᨻᩣ", value: "mbo" },
  { id: "ᨾᩮᩜᩣ", value: "mmo" },
  { id: "ᨾᩮ᩠ᨾᩣ", value: "mmo" },
  { id: "ᨾᩮ᩠ᨷᩣ", value: "mpo" },
  { id: "ᨶᩮᩣ᩠ᨴ", value: "ndo" },
  { id: "ᨶᩮᩣ᩠ᨶ", value: "nno" },
  { id: "ᨶᩮᩣ᩠ᨲ", value: "nto" },
  { id: "ᨶᩣ᩠ᨴ", value: "ndā" },
  { id: "ᨶᩣ᩠ᨶ", value: "nnā" },
  { id: "ᨶᩣ᩠ᨲ", value: "ntā" },
  { id: "ᩘ ᨣᩮᩤ", value: "ṅgo" },
  { id: "ᩘᨠᩮᩣ", value: "ṅko" },
  { id: "ᨬᩮ᩠ᨧᩣ", value: "ñco" },
  { id: "ᨬᩮ᩠ᨩᩣ", value: "ñjo" },
  { id: "ᨬᩮ᩠ᨬᩣ", value: "ñño" },
  { id: "ᨱᩮ᩠ᨯᩣ", value: "ṇḍo" },
  { id: "ᨱᩮ᩠ᨱᩣ", value: "ṇṇo" },
  { id: "ᨱᩮ᩠ᨭᩣ", value: "ṇṭo" },
  { id: "ᨷᩮ᩠ᨷᩣ", value: "ppo" },
  { id: "ᩁᩮ᩠ᩉᩣ", value: "rho" },
  { id: "ᩁᩮ᩠ᩅᩣ", value: "rvo" },
  { id: "ᩁᩮ᩠ᨿᩣ", value: "ryo" },
  { id: "ᨲᩮ᩠ᨲᩣ", value: "tto" },
  { id: "ᨲᩮ᩠ᩅᩣ", value: "tvo" },
  { id: "ᨭᩮ᩠ᨭᩣ", value: "ṭṭo" },
  { id: "ᩅᩮ᩠ᩉᩣ", value: "vho" },
  { id: "ᩅᩮ᩠ᩕᩣ", value: "vro" },
  { id: "ᩅᩮ᩠ᨿᩣ", value: "vyo" },
  { id: "ᨿᩮ᩠ᩉᩣ", value: "yho" },
  { id: "ᨿᩮ᩠ᩕᩣ", value: "yro" },
  { id: "ᨿᩮ᩠ᩅᩣ", value: "yvo" },
  { id: "ᨿᩮ᩠ᨿᩣ", value: "yyo" },
  { id: "ᨻᩮ᩠ᨻ", value: "bbe" },
  { id: "ᨾᩮ᩠ᨻ", value: "mbe" },
  { id: "ᨧᩮ᩠ᨧ", value: "cce" },
  { id: "ᨬᩮ᩠ᨧ", value: "ñce" },
  { id: "ᨴᩮ᩠ᨴ", value: "dde" },
  { id: "ᨶᩮ᩠ᨴ", value: "nde" },
  { id: "ᨯᩮ᩠ᨯ", value: "ḍḍe" },
  { id: "ᨱᩮ᩠ᨯ", value: "ṇḍe" },
  { id: "ᨣᩮ᩠ᨣ", value: "gge" },
  { id: "ᩘᨣᩮ", value: "ṅge" },
  { id: "ᩁᩮ᩠ᩉ", value: "rhe" },
  { id: "ᩅᩮ᩠ᩉ", value: "vhe" },
  { id: "ᨿᩮ᩠ᩉ", value: "yhe" },
  { id: "ᨩᩮ᩠ᨩ", value: "jje" },
  { id: "ᨬᩮ᩠ᨩ", value: "ñje" },
  { id: "ᨠᩮ᩠ᨠ", value: "kke" },
  { id: "ᩘᨠᩮ", value: "ṅke" },
  { id: "ᨾᩮᩜ", value: "mmo" },
  { id: "ᨾᩮ᩠ᨾ", value: "mme" },
  { id: "ᨶᩮ᩠ᨶ", value: "nne" },
  { id: "ᨬᩮ᩠ᨬ", value: "ññe" },
  { id: "ᨱᩮ᩠ᨱ", value: "ṇṇe" },
  { id: "ᨾᩮ᩠ᨷ", value: "mpe" },
  { id: "ᨷᩮ᩠ᨷ", value: "ppe" },
  { id: "ᩉᩮ᩠ᩕ", value: "hre" },
  { id: "ᨠᩮ᩠ᩕ", value: "kre" },
  { id: "ᩅᩮ᩠ᩕ", value: "vre" },
  { id: "ᨿᩮ᩠ᩕ", value: "yre" },
  { id: "ᨶᩮ᩠ᨲ", value: "nte" },
  { id: "ᨲᩮ᩠ᨲ", value: "tte" },
  { id: "ᨱᩮ᩠ᨭ", value: "ṇṭe" },
  { id: "ᨭᩮ᩠ᨭ", value: "ṭṭe" },
  { id: "ᨴᩮ᩠ᩅ", value: "dve" },
  { id: "ᩉᩮ᩠ᩅ", value: "hve" },
  { id: "ᩁᩮ᩠ᩅ", value: "rve" },
  { id: "ᨲᩮ᩠ᩅ", value: "tve" },
  { id: "ᨿᩮ᩠ᩅ", value: "yve" },
  { id: "ᩉᩮ᩠ᨿ", value: "hye" },
  { id: "ᩁᩮ᩠ᨿ", value: "rye" },
  { id: "ᩅᩮ᩠ᨿ", value: "vye" },
  { id: "ᨿᩮ᩠ᨿ", value: "yye" },
  { id: "ᨾᩜᩣ", value: "mmā" },

  { id: "ᩜ", value: "᩠ma" },
  { id: "ᩱ", value: "᩠ai" },
  { id: "ᩴ", value: "᩠aṃ" },
  { id: "ᩥᩴ", value: "᩠iṃ" },
  { id: "ᩩᩴ", value: "᩠uṃ" },
  { id: "ᩣ", value: "᩠ā" },
  { id: "ᩤ", value: "᩠ā" },
  { id: "ᩥ", value: "᩠i" },
  { id: "ᩦ", value: "᩠ī" },
  { id: "ᩩ", value: "᩠u" },
  { id: "ᩪ", value: "᩠ū" },
  { id: "ᩮ", value: "᩠e" },
  { id: "ᩮᩣ", value: "᩠o" },

  { id: "ᨾᩜ", value: "mma" },
  { id: "ᨻ᩠ᨿ᩠", value: "by" },
  { id: "ᨭᩛ᩠", value: "ṭṭh" },
  { id: "ᩔ᩠", value: "ss" },
  { id: "ᩅ᩠ᩉ᩠", value: "vh" },
  { id: "ᩅ᩠ᨿ᩠", value: "vy" },
  { id: "ᩅᩕ᩠", value: "vr" },
  { id: "ᨿ᩠ᩉ᩠", value: "yh" },
  { id: "ᨿ᩠ᨿ᩠", value: "yy" },
  { id: "ᨿᩕ᩠", value: "yr" },
  { id: "ᨿ᩠ᩅ᩠", value: "yv" },
  { id: "ᩉ᩠ᨿ᩠", value: "hy" },
  { id: "ᩉᩕ᩠", value: "hr" },
  { id: "ᩉ᩠ᩅ᩠", value: "hv" },
  { id: "ᩁ᩠ᩅ᩠", value: "rv" },
  { id: "ᩁ᩠ᩉ᩠", value: "rh" },
  { id: "ᩁ᩠ᨿ᩠", value: "ry" },
  { id: "ᨡ᩠", value: "kh" },
  { id: "ᨥ᩠", value: "gh" },
  { id: "ᨨ᩠", value: "ch" },
  { id: "ᨫ᩠", value: "jh" },
  { id: "ᨬ᩠ᨬ᩠", value: "ññ" },
  { id: "ᨮ᩠", value: "ṭh" },
  { id: "ᨰ᩠", value: "ḍh" },
  { id: "ᨳ᩠", value: "th" },
  { id: "ᨵ᩠", value: "dh" },
  { id: "ᨹ᩠", value: "ph" },
  { id: "ᨽ᩠", value: "bh" },
  { id: "ᨠ᩠", value: "k" },
  { id: "ᨣ᩠", value: "g" },
  { id: "ᨧ᩠", value: "c" },
  { id: "ᨩ᩠", value: "j" },
  { id: "ᨬ᩠", value: "ñ" },
  { id: "ᩊ᩠", value: "ḷ" },
  { id: "ᨭ᩠", value: "ṭ" },
  { id: "ᨯ᩠", value: "ḍ" },
  { id: "ᨱ᩠", value: "ṇ" },
  { id: "ᨲ᩠", value: "t" },
  { id: "ᨴ᩠", value: "d" },
  { id: "ᨶ᩠", value: "n" },
  { id: "ᨷ᩠", value: "p" },
  { id: "ᨻ᩠", value: "b" },
  { id: "ᨾ᩠", value: "m" },
  { id: "ᩃ᩠", value: "l" },
  { id: "ᩈ᩠", value: "s" },
  { id: "ᩘ", value: "ṅ" },

  { id: "ᨻ᩠ᨿ", value: "bya" },
  { id: "ᨭᩛ", value: "ṭṭha" },
  { id: "ᩔ", value: "ssa" },
  { id: "ᩅ᩠ᩉ", value: "vha" },
  { id: "ᩅ᩠ᨿ", value: "vya" },
  { id: "ᩅᩕ", value: "vra" },
  { id: "ᨿ᩠ᩉ", value: "yha" },
  { id: "ᨿ᩠ᨿ", value: "yya" },
  { id: "ᨿᩕ", value: "yra" },
  { id: "ᨿ᩠ᩅ", value: "yva" },
  { id: "ᩉ᩠ᨿ", value: "hya" },
  { id: "ᩉᩕ", value: "hra" },
  { id: "ᩉ᩠ᩅ", value: "hva" },
  { id: "ᩁ᩠ᩅ", value: "rva" },
  { id: "ᩁ᩠ᩉ", value: "rha" },
  { id: "ᩁ᩠ᨿ", value: "rya" },
  { id: "ᨡ", value: "kha" },
  { id: "ᨥ", value: "gha" },
  { id: "ᨨ", value: "cha" },
  { id: "ᨫ", value: "jha" },
  { id: "ᨬ᩠ᨬ", value: "ñña" },
  { id: "ᨮ", value: "ṭha" },
  { id: "ᨰ", value: "ḍha" },
  { id: "ᨳ", value: "tha" },
  { id: "ᨵ", value: "dha" },
  { id: "ᨹ", value: "pha" },
  { id: "ᨽ", value: "bha" },
  { id: "ᨠ", value: "ka" },
  { id: "ᨣ", value: "ga" },
  { id: "ᨧ", value: "ca" },
  { id: "ᨩ", value: "ja" },
  { id: "ᨬ", value: "ña" },
  { id: "ᩊ", value: "ḷa" },
  { id: "ᨭ", value: "ṭa" },
  { id: "ᨯ", value: "ḍa" },
  { id: "ᨱ", value: "ṇa" },
  { id: "ᨲ", value: "ta" },
  { id: "ᨴ", value: "da" },
  { id: "ᨶ", value: "na" },
  { id: "ᨷ", value: "pa" },
  { id: "ᨻ", value: "ba" },
  { id: "ᨾ", value: "ma" },
  { id: "ᩃ", value: "la" },
  { id: "ᩈ", value: "sa" },
  { id: "ᩘ", value: "ṅa" },

  { id: "᩠ᩉ᩠", value: "᩠h" },
  { id: "ᩉ᩠", value: "h" },
  { id: "ᩉ", value: "ha" },
  { id: "᩠ᨿ", value: "᩠y" },
  { id: "ᨿ᩠", value: "y" },
  { id: "ᨿ", value: "ya" },
  { id: "ᩕ᩠", value: "᩠r" },
  { id: "ᩕ᩠", value: "᩠r" },
  { id: "aᩕ", value: "ra" },
  { id: "ᩕ", value: "r" },
  { id: "ᩁ᩠", value: "r" },
  { id: "ᩁ", value: "ra" },
  { id: "᩠ᩅ᩠", value: "᩠v" },
  { id: "ᩅ᩠", value: "v" },
  { id: "ᩅ", value: "va" },
  { id: "ᩋᩴ", value: "aṃ" },
  { id: "ᨠ᩠ᨠᩴ", value: "iṃ" },
  { id: "ᩏᩴ", value: "uṃ" },
  { id: "ᩋ", value: "a" },
  { id: "ᩋᩣ", value: "ā" },
  { id: "ᩍ", value: "i" },
  { id: "ᩎ", value: "ī" },
  { id: "ᩏ", value: "u" },
  { id: "ᩐ", value: "ū" },
  { id: "ᩑ", value: "e" },
  { id: "ᩒ", value: "o" },
  { id: "e᩠ā", value: "o" },
  { id: "a᩠", value: "" },
  { id: "᩠a", value: "" },
  { id: "nrd", value: "ndr" },
  { id: "nrt", value: "ntr" },
];

const char_tai_old_to_r = [
  { id: "ํ", value: "ฺaṃ" },
  { id: "ิํ", value: "ฺiṃ" },
  { id: "ุํ", value: "ฺuṃ" },
  { id: "า", value: "ฺā" },
  { id: "ิ", value: "ฺi" },
  { id: "ี", value: "ฺī" },
  { id: "ุ", value: "ฺu" },
  { id: "ู", value: "ฺū" },

  { id: "เข", value: "khe" },
  { id: "เฃ", value: "ghe" },
  { id: "เฉ", value: "che" },
  { id: "เณ", value: "jhe" },
  { id: "เฐ", value: "ṭhe" },
  { id: "เฒ", value: "ḍhe" },
  { id: "เถ", value: "the" },
  { id: "เธ", value: "dhe" },
  { id: "เผ", value: "phe" },
  { id: "เภ", value: "bhe" },
  { id: "โข", value: "kho" },
  { id: "โฃ", value: "gho" },
  { id: "โฉ", value: "cho" },
  { id: "โณ", value: "jho" },
  { id: "โฐ", value: "ṭho" },
  { id: "โฒ", value: "ḍho" },
  { id: "โถ", value: "tho" },
  { id: "โธ", value: "dho" },
  { id: "โผ", value: "pho" },
  { id: "โภ", value: "bho" },
  { id: "เก", value: "ke" },
  { id: "เค", value: "ge" },
  { id: "เจ", value: "ce" },
  { id: "เช", value: "je" },
  { id: "เญ", value: "ñe" },
  { id: "เฬ", value: "ḷe" },
  { id: "เฏ", value: "ṭe" },
  { id: "เฑ", value: "ḍe" },
  { id: "เฌ", value: "ṇe" },
  { id: "เต", value: "te" },
  { id: "เท", value: "de" },
  { id: "เน", value: "ne" },
  { id: "เบ", value: "pe" },
  { id: "เพ", value: "be" },
  { id: "เม", value: "me" },
  { id: "เล", value: "le" },
  { id: "เส", value: "se" },
  { id: "เง", value: "ṅe" },
  { id: "เห", value: "he" },
  { id: "เย", value: "ye" },
  { id: "เร", value: "re" },
  { id: "เว", value: "ve" },
  { id: "โก", value: "ko" },
  { id: "โค", value: "go" },
  { id: "โจ", value: "co" },
  { id: "โช", value: "jo" },
  { id: "โญ", value: "ño" },
  { id: "โฬ", value: "ḷo" },
  { id: "โฏ", value: "ṭo" },
  { id: "โฑ", value: "ḍo" },
  { id: "โฌ", value: "ṇo" },
  { id: "โต", value: "to" },
  { id: "โท", value: "do" },
  { id: "โน", value: "no" },
  { id: "โบ", value: "po" },
  { id: "โพ", value: "bo" },
  { id: "โม", value: "mo" },
  { id: "โล", value: "lo" },
  { id: "โส", value: "so" },
  { id: "โง", value: "ṅo" },
  { id: "โห", value: "ho" },
  { id: "โย", value: "yo" },
  { id: "โร", value: "ro" },
  { id: "โว", value: "vo" },
  { id: "ขฺ", value: "kh" },
  { id: "ฃฺ", value: "gh" },
  { id: "ฉฺ", value: "ch" },
  { id: "ณฺ", value: "jh" },
  { id: "ฐฺ", value: "ṭh" },
  { id: "ฒฺ", value: "ḍh" },
  { id: "ถฺ", value: "th" },
  { id: "ธฺ", value: "dh" },
  { id: "ผฺ", value: "ph" },
  { id: "ภฺ", value: "bh" },
  { id: "กฺ", value: "k" },
  { id: "คฺ", value: "g" },
  { id: "จฺ", value: "c" },
  { id: "ชฺ", value: "j" },
  { id: "ญฺ", value: "ñ" },
  { id: "ฬฺ", value: "ḷ" },
  { id: "ฏฺ", value: "ṭ" },
  { id: "ฑฺ", value: "ḍ" },
  { id: "ฌฺ", value: "ṇ" },
  { id: "ตฺ", value: "t" },
  { id: "ทฺ", value: "d" },
  { id: "นฺ", value: "n" },
  { id: "บฺ", value: "p" },
  { id: "พฺ", value: "b" },
  { id: "มฺ", value: "m" },
  { id: "ลฺ", value: "l" },
  { id: "สฺ", value: "s" },
  { id: "งฺ", value: "ṅ" },
  { id: "หฺ", value: "h" },
  { id: "ยฺ", value: "y" },
  { id: "รฺ", value: "r" },
  { id: "วฺ", value: "v" },

  { id: "ข", value: "kha" },
  { id: "ฃ", value: "gha" },
  { id: "ฉ", value: "cha" },
  { id: "ณ", value: "jha" },
  { id: "ฐ", value: "ṭha" },
  { id: "ฒ", value: "ḍha" },
  { id: "ถ", value: "tha" },
  { id: "ธ", value: "dha" },
  { id: "ผ", value: "pha" },
  { id: "ภ", value: "bha" },
  { id: "ก", value: "ka" },
  { id: "ค", value: "ga" },
  { id: "จ", value: "ca" },
  { id: "ช", value: "ja" },
  { id: "ญ", value: "ña" },
  { id: "ฬ", value: "ḷa" },
  { id: "ฏ", value: "ṭa" },
  { id: "ฑ", value: "ḍa" },
  { id: "ฌ", value: "ṇa" },
  { id: "ต", value: "ta" },
  { id: "ท", value: "da" },
  { id: "น", value: "na" },
  { id: "บ", value: "pa" },
  { id: "พ", value: "ba" },
  { id: "ม", value: "ma" },
  { id: "ล", value: "la" },
  { id: "ส", value: "sa" },
  { id: "ง", value: "ṅa" },
  { id: "ห", value: "ha" },
  { id: "ย", value: "ya" },
  { id: "ร", value: "ra" },
  { id: "ว", value: "va" },

  { id: "อํ", value: "aṃ" },
  { id: "อิํ", value: "iṃ" },
  { id: "อุํ", value: "uṃ" },
  { id: "อ", value: "a" },
  { id: "อา", value: "ā" },
  { id: "อิ", value: "i" },
  { id: "อี", value: "ī" },
  { id: "อุ", value: "u" },
  { id: "อู", value: "ū" },
  { id: "เอ", value: "e" },
  { id: "โอ", value: "o" },
  { id: "eฺā", value: "o" },
  { id: "aฺ", value: "" },
];
*/
export const roman_to_taitham = (
  input: string | undefined
): string | undefined => {
  if (typeof input === "undefined") {
    return input;
  }
  let txt = input.toLowerCase();

  try {
    for (const iterator of char_roman_to_tai) {
      txt = txt.replaceAll(iterator.id, iterator.value);
    }
  } catch (err) {
    //error
    console.error(err);
  }
  return txt;
};
